import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageData } from '@/app/page-data';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageSkeleton } from '@/components/common/PageSkeleton';
import { SectionContainer } from './SectionContainer';

export function PublicLayout({ children }: { children: ReactNode }) {
  const { data, loading } = usePageData();
  const location = useLocation();

  // A client-side navigation should land at the top, like a real page load.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (location.hash) return;
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  if (!data) return <PageSkeleton />;

  const { settings, menus, branches } = data.site;

  return (
    <div className="cng-page">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      {loading ? <div className="cng-route-progress" role="presentation" /> : null}
      <Header settings={settings} menu={menus.header} />
      <main className="cng-main" id="main-content">{children}</main>
      {/* The live site wraps the footer in a boxed container like every other section. */}
      <SectionContainer>
        <Footer settings={settings} menu={menus.footer} branches={branches} />
      </SectionContainer>
    </div>
  );
}
